



































import { defineComponent, ref } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { attachmentFileAdapter, checkFilesAllowAccept } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import { FilterSubject } from "@/components/VaultController/types";
import VaultSelectFiles from "@/components/VaultSelectFiles";

export default defineComponent({
  name: "VaultModal",
  components: { BaseSpinner, VaultSelectFiles, BaseInputFileWithPreview, BaseButton, BaseIconButton, BaseConfirm },
  props: {
    show: { type: Boolean, default: false },
    maxFiles: { type: Number, default: Number.POSITIVE_INFINITY },
    filterSubject: { type: Object as () => FilterSubject },
    accept: { type: Array as () => string[], default: () => ["image", "video", "audio", "document"] },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const hasSelection = ref(false);

    const { isMember } = useAuthUser();

    const addAttachment = async (files: File[]) => {
      emit("addAttachment", files);
      emit("close");
    };

    const addAttachmentFromVault = (files: VaultFile[]) => {
      if (!checkFilesAllowAccept(files, props.accept)) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Chosen file type is not allowed"), position: "top" });
        return;
      }
      const attachmentFiles = attachmentFileAdapter(files, false);
      emit("addAttachmentFromVault", attachmentFiles);
      emit("close");
    };

    return {
      loading,
      isMember,
      hasSelection,
      addAttachment,
      addAttachmentFromVault,
    };
  },
});
